import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/ActionCards/ActionCards.js
const ActionCards = createSectionForm({
  icon: "layout-column-line",
  title: "Action Cards",
  fields: [
    {
      name: "wholesalers",
      label: "Wholesalers Card",
      type: "group",
      icon: "store-2-line",
      fields: [
        { name: "title", label: "Title" },
        { name: "button_text", label: "Button Text", placeholder: "Learn more" },
        { name: "button_link", label: "Button Link", type: "link" },
        { name: "description", label: "Description", type: "richtext", height: 110 },
        {
          name: "benefits",
          label: "Benefits",
          type: "list",
          itemLabel: "Benefit",
          fields: [
            { name: "image", label: "Image", type: "media" },
            { name: "name", label: "Benefit", placeholder: "e.g. Car Dealerships" },
          ],
        },
      ],
    },
    {
      name: "build",
      label: "Build / Upgrade Card",
      type: "group",
      icon: "car-line",
      fields: [
        {
          name: "title",
          label: "Title",
          type: "textarea",
          rows: 2,
          help: "Basic HTML (e.g. <br>) is allowed.",
        },
        {
          name: "benefits",
          label: "Checklist",
          type: "list",
          itemLabel: "Checklist Item",
          fields: [
            { name: "name", label: "Text", placeholder: "e.g. Backed by Our 1-year Warranty" },
          ],
        },
        { name: "image", label: "Card Image", type: "media" },
      ],
    },
  ],
});

export default ActionCards;
